import { Colors } from '~/theme';
import BurgerWhite from 'public/assets/icons/burger_white.svg';
import MobileMenu from './MobileMenu';
import { Flex } from '~/components/wrappers/Flex';
import styled from 'styled-components';
import { Image } from '~/components/wrappers/Image';
import { useEffect } from 'react';
import { useLocation } from '@remix-run/react';

interface IMobileSidebar {
  isMobileNavigationOpen?: boolean;
  toggleMobileNavigation: (val: boolean) => void;
}

const MobileSidebar = ({
  isMobileNavigationOpen,
  toggleMobileNavigation,
}: IMobileSidebar) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isMobileNavigationOpen) {
      toggleMobileNavigation(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <MobileMenu
        isOpen={isMobileNavigationOpen}
        activeTab={pathname}
        toggleMobileNavigation={toggleMobileNavigation}
      />
      <StyledFlex $bgColor="transparent">
        <StyledButton onClick={() => toggleMobileNavigation(true)}>
          <Image
            src={BurgerWhite}
            alt="Open Broken Planet navigation menu"
            width={40}
            height={40}
            loading="eager"
          />
        </StyledButton>
      </StyledFlex>
    </>
  );
};

export default MobileSidebar;

const StyledFlex = styled(Flex)<{ $bgColor?: Colors | string }>`
  background-color: ${({ theme, $bgColor }) => {
    if (theme.colors[$bgColor as Colors]) {
      return theme.colors[($bgColor as Colors) || 'transparent'];
    }

    return $bgColor;
  }};
`;

const StyledButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  height: 2.5rem;

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  > img {
    max-width: 2.5rem;
    width: 100%;
  }
`;
